import { render, staticRenderFns } from "./diska.vue?vue&type=template&id=c816027c&scoped=true&"
import script from "./diska.vue?vue&type=script&lang=js&"
export * from "./diska.vue?vue&type=script&lang=js&"
import style0 from "./diska.vue?vue&type=style&index=0&id=c816027c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c816027c",
  null
  
)

export default component.exports